export enum Rule {
  VldHandbookView = 'vld-handbook:view',
  LessonsKriyaView = 'lessons:kriya:view',
  LessonsSupplementView = 'lessons:supplement:view',
  ForMeView = 'for-me:view'
}
